import React, { useState } from 'react';
import {
    MenuItem, Button, Select, DialogContent, DialogTitle, DialogActions, FormControl, InputLabel
} from '@material-ui/core';
import Uniq from 'lodash/uniq';
import { useEmployees } from '~/employees';
import { useDepartments } from '~/departments';
import { useGenerateEvals } from '~/evals';


const GenerateEvalsForm = props => {

    const { isOpen, onClose } = props;

    const [evalGroup, setEvalGroup] = useState(null);
    const [selectedDepartments, setSelectedDepartments] = useState([]);
    const [selectedEmployees, setSelectedEmployees] = useState([]);
    const [formType, setFormType] = useState('');

    const { data: departments } = useDepartments({ enabled: !!isOpen });
    const { data: employees } = useEmployees({ enabled: !!isOpen });
    const { mutate: generateEvals } = useGenerateEvals();

    const onSubmit = () => {

        const payload = {
            type: formType,
            ids: null
        };

        if (evalGroup === 'department') {
            const ids = (
                departments
                    .filter(department => selectedDepartments.includes(department.id))
                    .map(department => department.employees)
                    .flat()
                    .map(employee => employee.id)
            );

            payload.ids = Uniq(ids);
        }

        if (evalGroup === 'employees') {
            payload.ids = selectedEmployees;
        }

        generateEvals(payload);
        onClose();
    };

    if (!departments) {
        return 'Loading...';
    }

    return (
        <React.Fragment>
            <DialogTitle>Generate Evaluations</DialogTitle>
            <DialogContent>

                <FormControl fullWidth margin='normal'>
                    <InputLabel>Select Form</InputLabel>
                    <Select value={formType} onChange={e => setFormType(e.target.value)}>
                        <MenuItem value={'long'}>May Evaluation (Long Form)</MenuItem>
                        <MenuItem value={'short'}>November Evaluation (Short Form)</MenuItem>
                    </Select>
                </FormControl>


                {
                    formType.length > 1 && (
                        <FormControl fullWidth margin='normal'>
                            <InputLabel>Select Eval Group</InputLabel>
                            <Select value={evalGroup} onChange={e => setEvalGroup(e.target.value)}>
                                <MenuItem value={'all'}>All Employees</MenuItem>
                                <MenuItem value={'department'}>Departments</MenuItem>
                                <MenuItem value={'employees'}>Employees</MenuItem>
                            </Select>
                        </FormControl>
                    )
                }


                {
                    evalGroup === 'department' && (
                        <FormControl fullWidth margin='normal'>
                            <InputLabel>Select Departments</InputLabel>
                            <Select multiple value={selectedDepartments} onChange={e => setSelectedDepartments(e.target.value)}>
                                {(departments || []).map(department => (
                                    <MenuItem value={department.id}>{department.name}</MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    )
                }

                {
                    evalGroup === 'employees' && (
                        <FormControl fullWidth margin='normal'>
                            <InputLabel>Select Employees</InputLabel>
                            <Select multiple value={selectedEmployees} onChange={e => setSelectedEmployees(e.target.value)}>
                                {(employees || []).map(employee => (
                                    <MenuItem value={employee.id}>{employee.name}</MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    )
                }

            </DialogContent>

            <DialogActions>
                <Button onClick={onClose} variant='contained'>Cancel</Button>
                <Button onClick={onSubmit} variant='contained'>Submit</Button>
            </DialogActions>

        </React.Fragment>
    );

};


export default GenerateEvalsForm;
